// extracted by mini-css-extract-plugin
export var aircallIframe = "_n4-3";
export var fabContainer = "_n4-5";
export var fabRinging = "_n4-6";
export var loadingOverlay = "_n4-4";
export var pulse = "_n4-7";
export var widgetContent = "_n4-2";
export var widgetPanel = "_n4-0";
export var widgetPanelExpanded = "_n4-1";